function CustomSelect({ props }) {
  props.options = [...(props.options || [])];
  return (
    <div className="w-full">
      <select
        disabled={props.disabled}
        placeholder={props.placeholder || "Nhập " + props.label}
        defaultValue={props.defaultValue || ""}
        {...props.register(props.name, {
          required: props.isRequired && `${props.label} là bắt buộc !`,
          ...(props.validate ? { validate: props.validate } : {}),
          ...(props.pattern ? { pattern: props.pattern } : {}),
        })}
        className="w-full h-[43px] p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
        {...props}
      >
        {props &&
          props.options.map((option, key) => (
            <option key={key} value={option.value}>
              {option.label}
            </option>
          ))}
      </select>
      {props && (
        <p className="text-sm mt-1 min-h-[20px] text-red-500">
          {props.errors[props.name]?.message || "\u00A0"}
        </p>
      )}
    </div>
  );
}

export default CustomSelect;
